<template>
  <router-view />
</template>

<script setup></script>

<style lang="scss" src="@/assets/scss/app.scss"></style>
